<div class="space-y-6">
  <app-page-header
    [backTo]="['/payment-methods']"
    backLabel="Retour aux méthodes"
    title="Nouvelle méthode de paiement"
    subtitle="Déclare un nouveau PSP (wallet ou carte) utilisable par les transactions."
  />

  <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
    <app-payment-method-form
      mode="create"
      [submitting]="submitting()"
      [serverError]="serverError()"
      (save)="onSave($event)"
      (cancel)="onCancel()"
    />
  </section>
</div>
